import { render, staticRenderFns } from "./PayrollSummary.vue?vue&type=template&id=ed0a0c8e&scoped=true&"
import script from "./PayrollSummary.vue?vue&type=script&setup=true&lang=js&"
export * from "./PayrollSummary.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0a0c8e",
  null
  
)

export default component.exports